// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"168":"component---src-pages-terms-tsx","245":"component---src-pages-index-tsx"}[chunkId] + "-" + {"168":"f1f24c8277d19cb29e2b","245":"3bc9dd7d7694aab11efd"}[chunkId] + ".js";
};